export default {
  EXTERNAL_APPLICATION: 3,
  CONTACT_HIVE: 5,
  HIRED: 6,
};
